import Animation from '../../animations/animation'
import StyleTweeners from '../../area/style-tweeners'
import LinearCurve from '../../linear-curve'
import * as d3 from 'd3-selection'
import { interpolate } from 'd3-interpolate'
import { EPSILON } from 'chart-constants'

/*
 * This animation is used to take a serie that was previously
 * a area and turn it into a line.
 */
class FromAreaAnimation extends Animation {

  constructor (options) {
    super(options)
    this.styleTweeners = new StyleTweeners(this.styles)
  }

  match (serie) {
    if (!this.previous.allSerieTypes[serie.id]) {
      return false
    }
    return this.previous.allSerieTypes[serie.id].type === 'area'
  }

  animate (serie, entering, selection, merged, exiting) {
    this._initialInsert(entering) // Insert new elements
    entering.selectAll('path')
            .style('opacity', 0) // Hide for now

    let area = this.previous.allSerieTypes[serie.id].serie.selectAll('.area-group')

    // We need to move the area path
    // Transition the paths
    let areaTransition = area.transition(merged).duration(merged.duration())

    this.pathAdjuster.updateDrawing(areaTransition, LinearCurve, {
      x: this.scalers.x.center,
      y: this.yScale
    })

    let oldLine = area.selectAll('path.line')
      , newLine = entering.selectAll('path.line.data-line')

    areaTransition.tween('fade-out', this.styleTweeners.fadeOut(areaTransition, false, 1)) // Fade out the area fill
                  .tween('stroke', this.styleTweeners.adjustStroke(areaTransition, oldLine.style('stroke'), newLine.style('stroke')))
                  .tween('stroke-width-new', this.styleTweeners.adjustStrokeWidth(areaTransition, oldLine.style('stroke-width'), newLine.style('stroke-width')))
                  .end().then(() => {
                    entering.selectAll('path').style('opacity', 1)
                    entering.selectAll('.point').style('display', '')
                    area.remove()
                  }).catch(() => {
                    // interrupted transition, ignore
                  })

    // Put all the area points in the DOM and hide them w/ opacity so we can fade.
    area.selectAll('.point').style('display', 'block')
                            .style('opacity', EPSILON)

    // Add the inner circle if applicable
    let fromPoints = areaTransition.selectAll('.point')
      , toPoints = entering.selectAll('.point')

    this._transitionPoints(fromPoints, toPoints, 1)
  }

}

export default FromAreaAnimation
